// Collection Card Product Variants 
$(window).scroll(function() {
  // Find inner divs with specific classes
  $('.color-swatches').each(function() {
  // Find inner divs with specific classes
  var whiteDivs = $(this).find('.whitebox');
  var blackbox = $(this).find('.blackbox');
  var silverbox = $(this).find('.silverbox');

  // Remove excess divs for each class
  removeExcessDivs(silverbox);
  removeExcessDivs(blackbox);
  removeExcessDivs(whiteDivs);
});

function removeExcessDivs(divs) {
  // Check if there are more than one divs
  if (divs.length > 1) {
    // Remove the excess divs (keep only the first one)
    divs.slice(1).remove();
  }
}
});